import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks';
import { PlusOrange } from '../../../../../ui/icons/plusOrange';
import { TrashIcon } from '../../../../../ui/icons/trash';
import { MadfarmStaticSelect } from '../../../../../ui/molecules/select/newSelect/static';
import { optionsFormatter, OptionType, rolesOptions } from '../../../../../utils';
import { GetAllFunctions, resetGetAllFunctionsStatus } from '../../../boxFunzioni/slice';
import { addTrainingDefaultInternalTeacher, addTrainingDefaultInternalTeacherFunction, addUpdateTrainingDefaultInternalTeacher, addUpdateTrainingDefaultInternalTeacherFunction, setFunctions, setTrainingInternalTeacher, setTrainingInternalTeacherByIndex, setTrainingInternalTeacherFunction, setTrainingInternalTeacherFunctionByIndex, setUpdateTrainingInternalTeacher, setUpdateTrainingInternalTeacherByIndex, setUpdateTrainingInternalTeacherFunction, setUpdateTrainingInternalTeacherFunctionByIndex } from '../../slice';

export function InternalTeachersAdd() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const functionsState = useAppSelector(state => state.PMFunctions)

    useEffect(() => {
        dispatch(GetAllFunctions())
    }, [])

    useEffect(() => {
        if (functionsState.GetAllFunctionsStatus === 'successfully' && functionsState.GetAllFunctionsResponse !== undefined) {
            dispatch(resetGetAllFunctionsStatus())
            dispatch(setFunctions(functionsState.GetAllFunctionsResponse))
        }
    }, [functionsState.GetAllFunctionsStatus])

    const handleFuncOptions = (PMid: string): OptionType[] =>
        trainingState.functions
            .filter(f => f.personalManagementId === PMid)
            .map(ff => ({ value: ff.id, label: optionsFormatter(ff.assignedFunction, rolesOptions) } as OptionType))

    return (
        <div className="flex flex-col gap-4 pb-6 border-b border-neutral-200">
            <div className="flex items-center justify-between">
                <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Docenti interni</p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={() => {
                        dispatch(addTrainingDefaultInternalTeacher())
                        dispatch(addTrainingDefaultInternalTeacherFunction())
                    }}
                >
                    Aggiungi docente interno <PlusOrange color="#FF941A" size={20} />
                </button>
            </div>

            {trainingState.trainingCreationRequest.internalTeacher.map((t, index) => (
                <div key={index} className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-4 items-end">
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Nome e cognome"
                            placeholder="Seleziona il docente interno"
                            options={trainingState.PMResources}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setTrainingInternalTeacherByIndex({ data: newValue, index }))
                            }}
                            defaultValue={trainingState.trainingCreationRequest.internalTeacher[index]}
                            value={trainingState.trainingCreationRequest.internalTeacher[index]}
                            noOptionsMessage={""}
                        />
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Funzione"
                            placeholder="Funzione del docente interno"
                            options={handleFuncOptions(t) || []}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setTrainingInternalTeacherFunctionByIndex({ data: newValue, index }))
                            }}
                            defaultValue={trainingState.trainingCreationRequest.internalTeacherFunction[index]}
                            value={trainingState.trainingCreationRequest.internalTeacherFunction[index]}
                            error={trainingState.trainingErrors.internalTeacherFunction}
                            errorLabel="Nessuna funzione specificata"
                            noOptionsMessage={""}
                        />
                        <button
                            className="p-1 rounded hover:bg-neutral-100 transition-colors mb-1"
                            onClick={() => {
                                dispatch(setTrainingInternalTeacher(trainingState.trainingCreationRequest.internalTeacher.filter((_, idx) => idx !== index)))
                                dispatch(setTrainingInternalTeacherFunction(trainingState.trainingCreationRequest.internalTeacherFunction.filter((_, idx) => idx !== index)))
                            }}
                        >
                            <TrashIcon color="#8383AD" size={20} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}

export function InternalTeachersEdit() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const functionsState = useAppSelector(state => state.PMFunctions)

    useEffect(() => {
        dispatch(GetAllFunctions())
    }, [])

    useEffect(() => {
        if (functionsState.GetAllFunctionsStatus === 'successfully' && functionsState.GetAllFunctionsResponse !== undefined) {
            dispatch(resetGetAllFunctionsStatus())
            dispatch(setFunctions(functionsState.GetAllFunctionsResponse))
        }
    }, [functionsState.GetAllFunctionsStatus])

    const handleFuncOptions = (PMid: string): OptionType[] =>
        trainingState.functions
            .filter(f => f.personalManagementId === PMid)
            .map(ff => ({ value: ff.id, label: optionsFormatter(ff.assignedFunction, rolesOptions) } as OptionType))

    return (
        <div className="flex flex-col gap-4 pb-6 border-b border-neutral-200">
            <div className="flex items-center justify-between">
                <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Docenti interni</p>
                <button
                    className="text-[#FF941A] flex items-center gap-2 text-sm font-semibold"
                    onClick={() => {
                        dispatch(addUpdateTrainingDefaultInternalTeacher())
                        dispatch(addUpdateTrainingDefaultInternalTeacherFunction())
                    }}
                >
                    Aggiungi docente interno <PlusOrange color="#FF941A" size={20} />
                </button>
            </div>

            {trainingState.trainingUpdateRequest.internalTeacher.map((t, index) => (
                <div key={index} className="rounded-xl border border-neutral-200 bg-white p-4">
                    <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-4 items-end">
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Nome e cognome"
                            placeholder="Seleziona il docente interno"
                            options={trainingState.PMResources}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateTrainingInternalTeacherByIndex({ data: newValue, index }))
                            }}
                            defaultValue={trainingState.trainingUpdateRequest.internalTeacher[index]}
                            value={trainingState.trainingUpdateRequest.internalTeacher[index]}
                            noOptionsMessage={""}
                        />
                        <MadfarmStaticSelect
                            menuPortalTargetIsNotBody
                            label="Funzione"
                            placeholder="Funzione del docente interno"
                            options={handleFuncOptions(t) || []}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setUpdateTrainingInternalTeacherFunctionByIndex({ data: newValue, index }))
                            }}
                            defaultValue={trainingState.trainingUpdateRequest.internalTeacherFunction[index]}
                            value={trainingState.trainingUpdateRequest.internalTeacherFunction[index]}
                            noOptionsMessage={""}
                        />
                        <button
                            className="p-1 rounded hover:bg-neutral-100 transition-colors mb-1"
                            onClick={() => {
                                dispatch(setUpdateTrainingInternalTeacher(trainingState.trainingUpdateRequest.internalTeacher?.filter((_, idx) => idx !== index)))
                                dispatch(setUpdateTrainingInternalTeacherFunction(trainingState.trainingUpdateRequest.internalTeacherFunction?.filter((_, idx) => idx !== index)))
                            }}
                        >
                            <TrashIcon color="#8383AD" size={20} />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}